/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  $('[data-swiper="gallery"]').each((i, container) => {
    createSwiper(container)
  })
  $('[data-swiper="gallery-quotes"]').each((i, container) => {
    createQuoteSwiper(container)
  })
}

function loadSwiper() {
  return import(/* webpackChunkName: "Swiper" */ 'swiper/swiper-bundle.js').then(m => m.default)
}

function createSwiper(container) {
  loadSwiper().then(Swiper => {
    const swiper = new Swiper(container, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 16,
      navigation: {
        nextEl: '[data-swiper-button-next]',
        prevEl: '[data-swiper-button-prev]',
      },
      pagination: {
        el: '[data-swiper-pagination]',
        type: 'fraction',
      },
    })
    setCaptionText(swiper)
    swiper.on('slideChange', () => setCaptionText(swiper))
  })
}

function createQuoteSwiper(container) {
  loadSwiper().then(Swiper => {
    const swiper = new Swiper(container, {
      slidesPerView: 1,
      autoHeight: true,
      pagination: {
        el: '[data-swiper-pagination]',
        type: 'bullets',
      },
    })
  })
}

function setCaptionText(swiper) {
  const slide = swiper.slides[swiper.activeIndex]
  const altText = $('img[alt]', slide).attr('alt')
  $('[data-swiper-caption]', swiper.el).text(altText)
}
